<template>
  <div></div>
</template>

<script>
export default {
  name: 'FooterMain'
};
</script>